import "../sass/main.scss";

import "./jquery/theme.min.js";
import "./jquery/multislider.min.js";
import "./jquery/jquery.fancybox.min.js";
import "./jquery/custom.js";
import "./jquery/jquery.fitvids.js";

import popups from "./popups";
import preventDefault from "./preventDefault";

popups.init();
preventDefault.init(document.querySelectorAll('#mainNav .menu-item-has-children > a'));